import React, {useState} from "react";
import {Button, Popover} from "antd";

export const StatusDropdown = ({onUpdateTask, openStatusModal, task, statuses}) => {
    const [open, setOpen] = useState(false);

    const handleStatusChange = async (statusId) => {
        await onUpdateTask(task.id, {status_id: statusId});
        setOpen(false);
    };

    return (
        <Popover
            open={open}
            onOpenChange={setOpen}
            trigger={["click"]}
            content={
                <div className={"max-w-32"}>
                    {statuses.map((item, i) => (
                        <Button
                            className={`text-white inline-flex w-full justify-center items-center text-xs font-normal mb-1 px-2`}
                            style={{backgroundColor: item.color}}
                            block
                            key={i}
                            onClick={() => handleStatusChange(item.id)}
                        >
                            {item.name}
                        </Button>
                    ))}
                    <Button
                        className={`inline-flex w-full justify-center items-center text-xs font-normal`}
                        type='text'
                        onClick={() => {
                            openStatusModal();
                            setOpen(false);
                        }}
                    >
                        Edit Labels
                    </Button>
                </div>
            }
            title={null}
            className="rt-Status__Dropdown relative inline-block text-left !p-0"
        >
            <Button
                block
                className={`text-white inline-flex w-full h-full justify-center items-center text-[13px] font-normal`}
                style={{backgroundColor: task.status ? task.status?.color : '#000000'}}
            >
                {task.status?.name}
            </Button>
        </Popover>
    );
};
